import script from "./WorkerSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkerSettings.vue?vue&type=script&setup=true&lang=js"

import "./WorkerSettings.vue?vue&type=style&index=0&id=1a7973f1&lang=scss"

const __exports__ = script;

export default __exports__